var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path0, _g6, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 73,
    viewBox: "0 0 156 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_2750)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0904 0C30.5518 0.613136 30.8362 1.31477 30.9311 2.09225C31.7717 1.36533 32.7325 1.1441 33.8197 1.42854C33.3141 1.67506 32.9095 2.03536 32.5935 2.50311C36.1838 2.13017 38.9903 3.41966 41.0194 6.3842C40.9941 6.43477 40.9625 6.44741 40.9182 6.40948C38.8702 4.93669 36.5883 4.30459 34.0726 4.51951C37.8462 5.44869 40.0333 7.82538 40.6338 11.6496C39.3885 10.1642 37.9853 8.86203 36.4177 7.73689C35.9626 7.42716 35.4885 7.168 34.9891 6.97205C36.7021 9.0959 37.3405 11.5042 36.9044 14.2033C36.228 11.8076 34.9512 9.79753 33.0739 8.17304C33.4342 9.99981 33.5037 11.8392 33.2761 13.6913C33.2066 14.2285 33.0992 14.7595 32.9411 15.2778C32.5239 13.5964 32.0246 11.9467 31.4367 10.3222C31.1144 9.44988 30.6719 8.64711 30.1093 7.9202C29.5468 8.68504 29.1043 9.51941 28.7819 10.4233C28.2067 12.0162 27.7137 13.6407 27.3028 15.2778C26.715 12.9075 26.6707 10.5371 27.1764 8.17304C25.3054 9.79121 24.0349 11.8013 23.3712 14.2033C22.916 11.4979 23.5545 9.08958 25.2864 6.97205C24.3762 7.38924 23.5229 7.9202 22.7327 8.55862C21.6076 9.48148 20.5899 10.4992 19.6671 11.6243C20.0716 8.35635 21.8415 6.10608 24.9767 4.8798C25.3749 4.7281 25.7858 4.608 26.203 4.51951C24.9893 4.37412 23.801 4.47526 22.6253 4.82924C21.4116 5.18953 20.2865 5.72682 19.2562 6.44109C20.2802 4.77867 21.7277 3.59664 23.5987 2.88869C24.9388 2.46519 26.2978 2.34509 27.6821 2.5284C27.366 2.05432 26.9615 1.6877 26.4558 1.42854C27.5114 1.15674 28.4659 1.35901 29.3129 2.04168C29.4519 1.31477 29.7111 0.632099 30.0777 0L30.0904 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.110012 11.3965C9.50932 13.2359 18.896 15.1069 28.2763 17.0158C28.4217 20.0878 28.5292 23.1535 28.6114 26.2129C25.6595 24.6895 22.6127 23.4064 19.4712 22.3571C16.1653 21.2699 12.7899 21.017 9.35762 21.5922C11.4056 21.6554 13.4283 21.8893 15.4384 22.3065C17.872 22.9955 20.2171 23.8994 22.4863 25.0182C24.2752 25.9095 26.0261 26.8576 27.7454 27.8563C24.9452 29.5883 22.1007 31.257 19.2184 32.8626C19.6861 33.4378 20.1792 33.994 20.6975 34.525C20.748 34.5566 20.7986 34.5566 20.8492 34.525C23.4534 32.8436 26.083 31.1938 28.7378 29.5946C28.959 34.4365 29.136 39.272 29.2751 44.1076C26.4369 40.9661 23.5798 37.8309 20.7228 34.702C19.8441 35.2709 18.915 35.7576 17.9415 36.1558C16.0263 36.7753 14.0857 36.8764 12.1199 36.4655C11.4246 36.2885 10.723 36.1179 10.0276 35.9535C13.3525 35.7955 16.3676 34.7589 19.0667 32.8373C12.6951 25.8399 6.35515 18.83 0.0278393 11.8073C-0.0164076 11.6556 0.00887638 11.5166 0.103691 11.3965H0.110012Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8117 11.3976C60.1657 11.3217 60.311 11.4545 60.2478 11.8084C53.8889 18.8058 47.549 25.8157 41.2216 32.8384C43.9207 34.7726 46.9295 35.8092 50.2607 35.9546C49.1798 36.2391 48.0926 36.4792 46.9927 36.6689C44.7677 36.8838 42.6692 36.4603 40.7096 35.392C40.3177 35.1645 39.9258 34.9306 39.5339 34.7031C36.6895 37.8383 33.8451 40.9735 31.0069 44.1087C30.988 44.0139 30.9753 43.919 30.9564 43.8306C31.1333 39.0835 31.3293 34.3428 31.5442 29.5957C34.1864 31.2202 36.8159 32.8636 39.4328 34.5261C39.4834 34.5577 39.5339 34.5577 39.5845 34.5261C40.0649 33.9698 40.5579 33.4262 41.0636 32.8889C38.1876 31.2644 35.3431 29.583 32.5366 27.8574C35.7982 25.8853 39.2179 24.2418 42.8019 22.927C44.0787 22.4656 45.3872 22.1432 46.7335 21.9536C48.1242 21.7766 49.5211 21.6565 50.9244 21.5933C47.549 21.0244 44.2241 21.2646 40.9625 22.3076C37.7641 23.3695 34.6668 24.6716 31.6643 26.2203C31.7212 23.1546 31.835 20.0889 31.9993 17.0232C41.2722 15.1459 50.5451 13.2686 59.8117 11.4039V11.3976Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.118 22.7121H129.324V29.8295H122.118V22.7121ZM129.324 11.7578H133.066V33.5715H129.324C129.336 32.3832 129.324 31.2012 129.28 30.0128C128.11 31.1822 126.941 32.3579 125.765 33.5273C123.331 33.5715 120.898 33.5905 118.471 33.5715C118.458 29.8927 118.471 26.2076 118.515 22.5288C119.684 21.3594 120.854 20.1837 122.029 19.0143C124.463 18.9701 126.896 18.9511 129.324 18.9701V11.7578Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_469_2750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 11,
    width: 6,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.039 11.5918H134.962V15.5045H139.039V11.5918Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_469_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.164 11.7559H138.906V15.4094H135.164V11.7559Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_469_2750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 15,
    width: 15,
    height: 19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9593 15.1758H68.1239V33.7595H82.9593V15.1758Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_469_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.771 15.3149H82.8075V19.0569H71.9544V22.6157H82.8075C82.8201 25.0492 82.8075 27.4828 82.7632 29.9164C81.5623 31.1174 80.3613 32.3184 79.1603 33.5194C75.5131 33.5636 71.8659 33.5826 68.2123 33.5636V29.8216H79.0655V26.2629H68.2123C68.1997 23.7977 68.2123 21.3325 68.2566 18.8673C69.4449 17.6916 70.6143 16.5033 71.771 15.3086V15.3149Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_469_2750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 18,
    width: 16,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5895 18.7598H84.9185V33.7595H99.5895V18.7598Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_469_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.648 22.7108H95.8539V29.8282H88.648V22.7108ZM88.5532 18.9688H99.5011V33.5702H95.8539C95.8665 32.3819 95.8539 31.1999 95.8097 30.0115C94.6403 31.1809 93.4709 32.3566 92.2952 33.526C89.8616 33.5702 87.428 33.5892 85.0008 33.5702C84.9881 29.8914 85.0008 26.2063 85.045 22.5275C86.2334 21.3518 87.4027 20.1634 88.5595 18.9688H88.5532Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_469_2750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 18,
    width: 16,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.378 18.7598H101.543V33.7595H116.378V18.7598Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_469_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.688 18.9688H105.43V29.8282H112.548V18.9688H116.29C116.302 22.6223 116.29 26.2695 116.245 29.923C115.044 31.124 113.843 32.325 112.642 33.526C108.995 33.5702 105.348 33.5892 101.694 33.5702V18.9688H101.688Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_469_2750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 18,
    width: 6,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.039 18.7598H134.962V33.7595H139.039V18.7598Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_469_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.164 18.9688H138.906V33.5702H135.164V18.9688Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_469_2750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 18,
    width: 16,
    height: 16
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M155.827 18.7598H140.992V33.7595H155.827V18.7598Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_469_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.835 22.7108H151.953V29.8282H144.835V22.7108ZM144.652 18.9688H155.688V33.5702H151.946C151.959 32.3819 151.946 31.1999 151.902 30.0115C150.733 31.1809 149.563 32.3566 148.387 33.526C145.954 33.5702 143.52 33.5892 141.093 33.5702C141.08 29.8914 141.093 26.2063 141.137 22.5275C142.326 21.3518 143.495 20.1634 144.652 18.9688Z",
    fill: "white"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75732 72.663V58.7448H0.00795746V56.3921H12.563V58.7448H7.81363V72.663H4.75732Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9051 72.8829C13.1347 72.8829 11.5076 70.7501 11.5076 67.1441C11.5076 63.5381 13.1347 61.4053 15.9051 61.4053C18.3678 61.4053 19.841 62.9004 19.841 65.4071H19.8849V61.6252H22.7873V72.663H19.8849V68.8591H19.841C19.841 71.3877 18.3678 72.8829 15.9051 72.8829ZM14.4759 67.1441C14.4759 69.2989 15.4874 70.5522 17.2464 70.5522C19.0054 70.5522 20.0388 69.167 20.0388 67.1441C20.0388 65.0992 19.0054 63.714 17.2464 63.714C15.4874 63.714 14.4759 64.9893 14.4759 67.1441Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.433 72.663L28.6177 67.0342H28.5737V72.663H25.6713V55.7324H28.5737V66.8143H28.6177L33.0592 61.6252H36.4893L31.8059 66.8802L36.995 72.663H33.433Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5976 72.8829C39.1895 72.8829 37.1447 70.7501 37.1447 67.1441C37.1447 63.5161 39.1895 61.4053 42.5976 61.4053C45.9838 61.4053 48.0066 63.5161 48.0066 67.1441V67.4739H39.9591C40.069 69.4968 41.0365 70.6841 42.5976 70.6841C43.9609 70.6841 44.9064 69.9365 45.1922 68.7272H48.0066C47.5889 71.3438 45.588 72.8829 42.5976 72.8829ZM39.9811 66.4845H45.1702C44.9943 64.6595 44.0488 63.6041 42.5976 63.6041C41.1245 63.6041 40.179 64.6595 39.9811 66.4845Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5688 72.663L60.5591 66.1986H57.7227L53.1052 56.3921H56.6013L60.9109 65.9348H60.9549L65.2425 56.3921H68.5407L60.8449 72.663H57.5688Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2031 72.8829C69.5971 72.8829 67.4423 70.7501 67.4423 67.1441C67.4423 63.5381 69.5971 61.4053 73.2031 61.4053C76.8091 61.4053 78.9419 63.5381 78.9419 67.1441C78.9419 70.7501 76.8091 72.8829 73.2031 72.8829ZM73.2031 70.5522C74.9622 70.5522 75.9956 69.2989 75.9956 67.1441C75.9956 64.9893 74.9622 63.714 73.2031 63.714C71.4441 63.714 70.4107 64.9893 70.4107 67.1441C70.4107 69.2989 71.4441 70.5522 73.2031 70.5522Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8706 72.8829C82.4959 72.8829 81.1107 71.2118 81.1107 68.3534V61.6252H84.013V68.2215C84.013 69.7167 84.7606 70.5742 86.0579 70.5742C87.5091 70.5742 88.3666 69.4748 88.3666 67.5838V61.6252H91.269V72.663H88.3666V68.7712H88.3227C88.3227 71.3438 87.0254 72.8829 84.8706 72.8829Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0494 67.6718V72.663H94.147V61.6252H97.0494V66.1766H97.0934C97.0934 63.1643 98.3247 61.4053 100.414 61.4053C101.051 61.4053 101.667 61.5372 102.129 61.7571L101.271 64.3516C100.853 64.1098 100.282 63.9559 99.7319 63.9559C98.0389 63.9559 97.0494 65.3411 97.0494 67.6718Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.828 72.8829C109.914 72.8829 107.43 70.7061 107.122 66.9682H110.112C110.31 69.167 111.695 70.4423 113.872 70.4423C116.115 70.4423 117.412 69.5408 117.412 68.0016C117.412 66.1107 115.477 65.8248 113.344 65.495C110.662 65.1212 107.562 64.6595 107.562 61.0755C107.562 57.8872 109.892 56.1722 113.828 56.1722C117.434 56.1722 119.743 58.283 120.051 61.845H117.038C116.906 59.8002 115.675 58.6128 113.674 58.6128C111.761 58.6128 110.64 59.4264 110.64 60.8336C110.64 62.4387 112.421 62.7245 114.466 63.0324C117.214 63.4501 120.512 63.9339 120.512 67.6938C120.512 70.948 118.028 72.8829 113.828 72.8829Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M127.629 72.8829C124.22 72.8829 122.176 70.7501 122.176 67.1441C122.176 63.5161 124.22 61.4053 127.629 61.4053C131.015 61.4053 133.038 63.5161 133.038 67.1441V67.4739H124.99C125.1 69.4968 126.067 70.6841 127.629 70.6841C128.992 70.6841 129.937 69.9365 130.223 68.7272H133.038C132.62 71.3438 130.619 72.8829 127.629 72.8829ZM125.012 66.4845H130.201C130.025 64.6595 129.08 63.6041 127.629 63.6041C126.155 63.6041 125.21 64.6595 125.012 66.4845Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.136 72.8829C136.365 72.8829 134.738 70.7501 134.738 67.1441C134.738 63.5381 136.365 61.4053 139.136 61.4053C141.598 61.4053 143.071 62.9004 143.071 65.4071H143.115V61.6252H146.018V72.663H143.115V68.8591H143.071C143.071 71.3877 141.598 72.8829 139.136 72.8829ZM137.706 67.1441C137.706 69.2989 138.718 70.5522 140.477 70.5522C142.236 70.5522 143.269 69.167 143.269 67.1441C143.269 65.0992 142.236 63.714 140.477 63.714C138.718 63.714 137.706 64.9893 137.706 67.1441Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.233 72.8829C150.881 72.8829 149.495 71.5636 149.495 69.3209V63.626H147.912V61.6252H149.671V57.9312H152.574V58.8547C152.574 60.2619 151.518 61.2514 149.759 61.5812V61.6252H155.828V63.626H152.398V68.9471C152.398 69.9585 153.035 70.5522 154.157 70.5522C154.685 70.5522 155.234 70.4203 155.63 70.2004V72.3772C154.97 72.685 154.069 72.8829 153.233 72.8829Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_2750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.819,
    height: 44.1015,
    fill: "white",
    transform: "translate(0.00879669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.924a29d00e4c6b8d5446064bdf3f395b.svg";
export { ForwardRef as ReactComponent };